const stringToArrayBuffer = (str: string) => {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i += 1) {
    bufView[i] = str.charCodeAt(i);
  }

  return buf;
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
};

const encryptDataWithPublicKey = (data: any, keyPair: CryptoKey) => {
  const stringBuffer = stringToArrayBuffer(data);

  return window.crypto.subtle.encrypt(
    {
      name: 'RSA-OAEP',
    },
    keyPair,
    stringBuffer,
  );
};

export const ecryptedWithJwkPublickKey = async (jwk: JsonWebKey, data: any) => {
  try {
    const keyPair = await window.crypto.subtle.importKey(
      'jwk',
      jwk,
      {
        name: 'RSA-OAEP',
        hash: { name: 'SHA-256' },
      },
      false,
      ['encrypt'],
    );
    const buffer = await encryptDataWithPublicKey(data, keyPair);
    const resultBase64 = arrayBufferToBase64(buffer);

    return resultBase64;
  } catch (error) {
    return null;
  }
};
